// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tag_aBYX8 {
    display: inline-block;
}

.tagHolder_uknX6 {
    display: flex;
    align-items: center;
}

.option_LFUJw {
    width: 100%;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/molten/lib/dataViewers/aggregations/util/Autosuggest.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf","sourcesContent":[".tag {\n    display: inline-block;\n}\n\n.tagHolder {\n    display: flex;\n    align-items: center;\n}\n\n.option {\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tag": `tag_aBYX8`,
	"tagHolder": `tagHolder_uknX6`,
	"option": `option_LFUJw`
};
export default ___CSS_LOADER_EXPORT___;
